<asl-google-signin-button
  type="standard"
  size="large"
  shape="pill"
  theme="outline"
  [text]="text()"
  logo_alignment="center"
  locale="{{ locale }}"
>
</asl-google-signin-button>

@defer (when showSocialRegistration()) {
  <ef-drawer [(isOpen)]="showSocialRegistration" #drawer (isOpenChange)="onSocialRegistrationRejected()">
    @if (!drawer.isClosed()) {
      <ef-social-register-form
        [googleToken]="googleAuthToken()"
        (success)="onSocialRegistrationSuccess()"
      ></ef-social-register-form>
    }
  </ef-drawer>
} @loading (after 200ms; minimum 1s) {
  <div class="fixed -inset-1 bg-backdrop flex items-center justify-center z-10">
    <ef-spinner class="text-primary w-10 h-10"></ef-spinner>
  </div>
} @error {
  <ef-defer-error></ef-defer-error>
}
